<div class="l-carousel01__view">
  <div class="l-carousel01__wrap">
    <div class="l-carousel01__inner">
      <button
        *ngIf="isScrollLeft"
        id="{{ id }}-block-slider-left-button"
        class="l-carousel01__arrow l-carousel01__arrow--prev is-available"
        [attr.aria-label]="'alt.switchToLeftScreen1' | staticMsg"
        (click)="scrollLeft()"
      >
        <img
          src="assets/images/btn_arrow_prev_36.svg"
          width="36"
          height="36"
          [attr.alt]="'alt.switchToLeftScreen1' | staticMsg"
          aria-hidden="true"
        />
      </button>
      <ng-content></ng-content>
      <button
        *ngIf="isScrollRight"
        id="{{ id }}-block-slider-right-button"
        class="l-carousel01__arrow l-carousel01__arrow--next is-available"
        [attr.aria-label]="'alt.switchToRightScreen1' | staticMsg"
        (click)="scrollRight()"
      >
        <img
          src="assets/images/btn_arrow_next_36.svg"
          width="36"
          height="36"
          [attr.alt]="'alt.switchToRightScreen1' | staticMsg"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</div>
